/* eslint-disable arrow-body-style */
/* eslint-disable no-return-await */
import axiosApi from './inteceptor';
import utils from './utils';

const API_ADMIN = `${utils.svcUrl()}pipeline`;

export default {
  createPipeline: data => {
    return new Promise((resolve, reject) => {
      axiosApi
        .post(`${API_ADMIN}/create`, data)
        .then(result => {
          resolve(result.data);
        })
        .catch(error => reject(error));
    });
  },
  getAlPipelines: () => {
    return new Promise((resolve, reject) => {
      axiosApi
        .get(`${API_ADMIN}/getAll/list`)
        .then(result => {
          resolve(result.data);
        })
        .catch(error => reject(error));
    });
  },
  addNewSegmentToPipeline: (data) => {
    return new Promise((resolve, reject) => {
      axiosApi
        .post(`${API_ADMIN}/add/segment`, data)
        .then(result => {
          resolve(result.data);
        })
        .catch(error => reject(error));
    });
  },
  deleteSegmentToPipeline: (data) => {
    return new Promise((resolve, reject) => {
      axiosApi
        .put(`${API_ADMIN}/remove/segment`, data)
        .then(result => {
          resolve(result.data);
        })
        .catch(error => reject(error));
    });
  },
  getPipelineDetails: (pipelineId) => {
    return new Promise((resolve, reject) => {
      axiosApi
        .get(`${API_ADMIN}/details/${pipelineId}`)
        .then(result => {
          resolve(result.data);
        })
        .catch(error => reject(error));
    });
  },
  changeSegmentOrder: (data) => {
    return new Promise((resolve, reject) => {
      axiosApi
        .put(`${API_ADMIN}/change/segment/order`, data)
        .then(result => {
          resolve(result.data);
        })
        .catch(error => reject(error));
    });
  },
};
